import { CreateFeedbackRequestDto, FeedbackDto } from '@careapp-group/ng-sdk';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';

export class FeedbackActions extends CaEntityActionsFactory<
  FeedbackDto,
  Omit<CreateFeedbackRequestDto, 'organisationId'>,
  CreateFeedbackRequestDto,
  BaseFilterType
> {
  constructor() {
    super('feedback');
  }
}

export const Feedback = new FeedbackActions();
